import { IconName } from "halifax";
import React from "react";

export const EXPERIENCES_INFO_MODAL_SUBHEADING_TEXT = () => (
  <>
    Book <strong>tours and activities</strong> you’ll love with elevated travel
    benefits.
  </>
);

export const EXPERIENCES_INFO_MODAL_POINTS: {
  icon: IconName;
  text: JSX.Element;
}[] = [
    {
      icon: IconName.RedeemRewardsIcon,
      text: (
        <>
          We’ve curated activities that match the quality and care you expect as a
          Capital One traveler.
        </>
      ),
    },
    {
      icon: IconName.RecognitionIcon,
      text: (
        <>
          Every activity you see is highly rated by fellow travelers, so you can
          spend less time researching and more time exploring.
        </>
      ),
    },
    {
      icon: IconName.EntertainmentTicketsIcon,
      text: (
        <>
          From iconic sights to hidden gems, each activity is powered by Viator
          and chosen for quality you can trust.
        </>
      ),
    },
  ];
